import { systemEngineEnvironment } from "services/environment/systemEngine";

import { NetworkPolicy } from "./types";

export const getNetworkPolicies = async () => {
  const result = await systemEngineEnvironment.execute<NetworkPolicy>(
    `
SELECT
  np.*,
  filter(x -> x <> '', array_distinct(array_agg(sa.service_account_name))) as service_accounts,
  filter(x -> x <> '', array_distinct(array_agg(l.login_name))) as logins
FROM information_schema.network_policies np

LEFT JOIN
  information_schema.service_accounts sa
ON
  np.network_policy_name = sa.network_policy_name

LEFT JOIN
  information_schema.logins l
ON
  np.network_policy_name = l.network_policy_name

GROUP BY ALL
`
  );
  const [response] = result;
  return response?.rows ?? [];
};
